import React from "react";
import { InputJson } from "nq-component";
import InputFactory from "../../../../components/InputFactory";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import FormFactory from "../../../../components/FormFactory";
import TaxFormPresenter from "./TaxFormPresenter";

class TaxFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new TaxFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "tax-table";
  }
  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  render() {
    const object = this.state.object;

    // console.warn("OBJECT: ", object);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    console.warn("SCEMA: ", schema);
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Update ";
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <FormFactory
                          schema={schema}
                          object={object}
                          // disabled={true}
                          onChange={this.onChange.bind(this)}
                        />

                        <div className="p-0, w-100">
                          <label>
                            Compensation Level
                            <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            _type="parseNumber"
                            field="compensation"
                            object={object}
                            placeholder="Compensation Level"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0, w-100">
                          <label>
                            Amount From<span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            _type="parseNumber"
                            field="from"
                            object={object}
                            placeholder="Amount From"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0, w-100">
                          <label>
                            Amount To<span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            _type="parseNumber"
                            field="to"
                            object={object}
                            placeholder="Amount To"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0, w-100">
                          <label>
                            Initial Tax<span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            _type="parseNumber"
                            field="initial"
                            object={object}
                            placeholder="Initial Tax"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0, w-100">
                          <label>
                            Percent Multiplier
                            <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            _type="parseNumber"
                            field="percent"
                            percent={"percent"}
                            object={object}
                            placeholder="  Percent Multiplier"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(TaxFormPage);
